import { BehaviorSubject, map, Observable, take } from 'rxjs';
import { AdminUsersFiltersModel } from '../../application/models';

export class AdminUsersFiltersStorage {
  private readonly filtersSubject: BehaviorSubject<AdminUsersFiltersModel> =
    new BehaviorSubject<AdminUsersFiltersModel>({ search: '' });

  filters$: Observable<AdminUsersFiltersModel> = this.filtersSubject.asObservable();

  patchContext(state: Partial<AdminUsersFiltersModel>): Observable<void> {
    return this.filtersSubject.asObservable().pipe(
      take(1),
      map((context: AdminUsersFiltersModel) => this.filtersSubject.next({ ...context, ...state }))
    );
  }
}
